import React from 'react'

import { Row, Text } from 'Components/UI'

import { CancelSvg, CheckboxCircleSvg } from 'Assets/Svg'

import { useResponsiveLayout } from 'Hooks'

import { GALLERY_ITEMS } from './constants'
import { Card, Container } from './styles'

function Gallery() {
  const { isDesktop } = useResponsiveLayout()

  return (
    <Container
      gap={isDesktop ? 7 : 5}
      gridTemplateColumns={isDesktop ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)'}
    >
      {GALLERY_ITEMS.map(item => (
        <Card key={item.id} px={[6, 6, 6, 9]} py={4}>
          {item.points.map(point => (
            <Row gap={5} key={point.id}>
              <Row>{item.positive ? <CheckboxCircleSvg /> : <CancelSvg />}</Row>

              <Text body medium mt="1px" screen20>
                {point.text}
              </Text>
            </Row>
          ))}
        </Card>
      ))}
    </Container>
  )
}

export default Gallery
